import { Box, FormHelperText } from '@mui/material';
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomTextArea from 'src/components/forms/theme-elements/CustomTextArea';

const FormTextArea = ({
  name,
  label,
  required = false,
  value,
  onChange,
  error,
  helperText,
  ...props
}) => {
  return (
    <Box mb={2}>
      {label && <CustomFormLabel margin="0" required={required}>{label}</CustomFormLabel>}
      <CustomTextArea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        {...props}
      />
      {error && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  );
};

export default FormTextArea;